import {
  ColDef,
  GridOptions,
  GridReadyEvent,
  IRowNode,
  SuppressKeyboardEventParams,
} from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import React, { CSSProperties, useMemo } from 'react';
import { DefaultTheme } from 'styled-components';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

interface IGridProps {
  onGridEvent?: (event: GridReadyEvent) => void;
  hasExternalFilter?: boolean;
  theme?: DefaultTheme;
  gridOptions?: GridOptions;
  style?: CSSProperties;
  columns: ColDef[];
  defaultColDef?: ColDef;
  rowData: any[];
  filterFunction?: (node: IRowNode) => boolean;
  suppressKeyboardEvents?: (params: SuppressKeyboardEventParams) => boolean;
}

const Grid: React.FC<IGridProps> = (props) => {
  const defaultColDef = useMemo<ColDef<any,any>>(()=> { 
    return { resizable: true } as ColDef<any, any>
  }, []);
  
  return (
    <div data-testid="Grid"
      className='ag-theme-alpine-dark'
      style={{
        height: '100%',
        width: '100%',
        fontSize: '0.75rem',
        fontFamily: '"Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif'
      }}
    >
      <AgGridReact
        rowData={props.rowData}
        columnDefs={props.columns}
        defaultColDef={defaultColDef}
        onGridReady={props.onGridEvent}
        gridOptions={props.gridOptions}
        isExternalFilterPresent={() => props.hasExternalFilter || false}
        doesExternalFilterPass={props.filterFunction}
      />
    </div>
  );
};

export default Grid;
